// user object repository

import http, {buildUrl} from '../services/http'
import auth from '../services/auth'
import store from '../store'
const BASE_ROUTE = '/media_platform/user'
let USER_URL = '/auth/user/'

import Vue from 'vue'
const bus = new Vue()
const FileSaver = require('file-saver')

export default {
  fetchUsersList: function (getParams = {}) {
    let queryData = encodeQueryData(getParams)
    const url = `${BASE_ROUTE}/?${queryData}`
    return http.get(url, auth.getAuthHeader())
      .then(apiListToModels)
  },
  fetchUserDetails: function (userId) {
    return http.get(`${BASE_ROUTE}/${userId}/`, auth.getAuthHeader())
      .then(apiToDetailModel)
  },
  fetchMyUserDetails: function (userId) {
    return http.get(`${USER_URL}`, auth.getAuthHeader())
      .then(apiToDetailMyUserModel)
  },
  exportAllUsers: function () {
    const opts = {
      headers: auth.getAuthHeader()
    }
    const url = buildUrl('/accounts/export/csv/')
    return fetch(url, opts).then(function (response) {
      if (response.ok) {
        return response.text()
      }
      throw response.status
    }).then(downloadCSV).catch((error) => {
      console.log(error)
      this.bus.$emit('request-error', error)
    })
  },
  bus: bus
}

function downloadCSV (payload) {
  const blob = new Blob([payload], {type: 'text/csv;charset=utf-8'})
  FileSaver.saveAs(blob, 'users.csv')
}

// convert the backend api format to the internal frontend user model
function apiToListModel (payload) {
  const marker = {
    id: payload.pk,
    first_name: payload.first_name,
    last_name: payload.last_name,
    valid_records_amt: payload.valid_records_amt,
    all_records_amt: payload.all_records_amt,
    user_groups: payload.user_groups
  }
  return marker
}

function apiToDetailMyUserModel (payload) {
  const userData = {
    user_group_list: payload.user_group_list,
    consumer_group: payload.consumer_group,
    departments: payload.departments
  }
  store.commit('SET_CONSUMER_GROUP', payload.consumer_group)
  store.commit('SET_EDITOR_CONSUMERS', payload.editor_consumer_list)
  return userData
}

function apiToDetailModel (payload) {
  const marker = {
    id: payload.pk,
    first_name: payload.first_name,
    last_name: payload.last_name,
    email: payload.last_name,
    birthdate: payload.birthdate,
    place: payload.place,
    date_joined: payload.date_joined,
    picture: payload.picture,
    user_groups: payload.user_groups,
    valid_records_amt: payload.valid_records_amt,
    all_records_amt: payload.all_records_amt,
    events_amt: payload.events_amt
  }
  return marker
}

// convert a backend response to a list of marker models
function apiListToModels (payload) {
  return payload.map(apiToListModel)
}

function encodeQueryData (data) {
  const ret = []
  for (let d in data) {
    ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]))
  }
  return ret.join('&')
}

export {
  BASE_ROUTE
}
